var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeslashoutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5713 4.35645C19.8775 5.90071 20.3838 7.35917 20.3975 7.40039L20.502 7.7168L20.3965 8.0332C20.3683 8.12137 18.0816 14.7168 10.502 14.7168C8.45685 14.7168 6.7989 14.2332 5.46484 13.5303L7.36719 12.1992C8.25806 12.518 9.29609 12.7168 10.502 12.7168C15.8212 12.7168 17.8844 8.8748 18.3857 7.7168C18.1882 7.2603 17.7448 6.38354 16.9531 5.48926L18.5713 4.35645ZM10.502 0.716797C12.5465 0.716797 14.2042 1.19975 15.5381 1.90234L13.6357 3.2334C12.7451 2.91482 11.7073 2.7168 10.502 2.7168C5.18268 2.7168 3.11946 6.5588 2.61816 7.7168C2.8156 8.17311 3.25875 9.04943 4.0498 9.94336L2.43164 11.0762C1.12613 9.5323 0.620103 8.07443 0.606445 8.0332L0.501953 7.7168L0.607422 7.40039C0.635644 7.31221 2.92233 0.716797 10.502 0.716797ZM13.4775 7.92188C13.3706 9.47031 12.0656 10.7168 10.502 10.7168C10.2112 10.7168 9.92993 10.6718 9.66309 10.5918L13.4775 7.92188ZM10.502 4.7168C10.5935 4.7168 10.679 4.73714 10.7686 4.74414C10.6531 4.94816 10.5685 5.17145 10.5283 5.40918L7.5293 7.50781C7.58355 6.7906 7.88844 6.11348 8.39746 5.60156C8.95592 5.04009 9.71219 4.72204 10.502 4.7168Z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.501953 14.7168L20.502 0.716797",
    stroke: "#4A4A4A",
    strokeWidth: 1.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeslashoutline);
export default __webpack_public_path__ + "static/media/eye.slash.outline.1bc0406fa524dd5cd3b97b469b72b499.svg";
export { ForwardRef as ReactComponent };